
import { SyntheticEvent } from 'react';
import styled from 'styled-components';
import { Featured } from 'src/types';
import { formatLink } from 'src/utils/featuredPosts';
import i18n from 'src/utils/translate';
import { Title } from './normalFeaturedPost';

type Props = {
  featuredPost: Featured;
  onClick: (e: SyntheticEvent) => void;
  onDismiss: () => void;
}

export default function StickyFeaturedPost({featuredPost, onDismiss, onClick}: Props) {
  const formattedLink = formatLink(featuredPost.callToActionUrl);

  return (
    <Container>
      <ContainerInner>
        <Title className="results-post__title">
          <a
            href={formattedLink}
            rel="nofollow ugc"
            target="_blank"
            onClick={onClick}
          >
            {featuredPost.title}
          </a>
          <LinkButton onClick={onDismiss}>{i18n.t('Hide')}</LinkButton>
        </Title>
        <Link
          className="btn btn-secondary"
          href={formattedLink}
          rel="nofollow ugc"
          target="_blank"
          onClick={onClick}
        >
          <span className="featured-post__call-to-action">
            {featuredPost.callToActionText}
          </span>
        </Link>
      </ContainerInner>
    </Container>
  );
}
const Container = styled.div`
  background-color: ${props => props.theme.colorWhite};
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  box-shadow: ${props => props.theme.shadowTop};
  z-index: 1050;
`;
const ContainerInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 15px 20px;

  @media (${props => props.theme.underScreenSmall}) {
    padding: 15px;
  }
`;
const Link = styled.a`
  margin-bottom: 0;
`;
const LinkButton = styled.button`
  border: 0;
  padding: 0 0 14px 14px;
  -webkit-appearance: none;
  background-color: transparent;
  color: ${props => props.theme.colorGreyDark};
`;
